
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { BehaviorFields, BehaviorKey, Device } from '~/interfaces/device.interface';
import { DevicesModule } from '~/store/modules/devices';

@Component
export default class Behavior extends Vue {
    @Prop() device!: Device;

    localBehavior: BehaviorFields = {};

    get behavior() {
        return this.device?.filteredBehavior;
    }

    @Watch('behavior', { immediate: true, deep: true })
    handler() {
        this.resetBehavior();
    }

    modifyBehaviorValue(value: boolean, key: BehaviorKey) {
        this.localBehavior[key] = value;
    }

    setBehavior() {
        if (this.device) {
            this.device.setBehavior(this.localBehavior);
        }
    }

    resetBehavior() {
        this.localBehavior = JSON.parse(JSON.stringify(this.behavior));
    }

    get currentGatewayType() {
        return DevicesModule.currentGateway?.type;
    }
}
